import { Action, createReducer, on } from '@ngrx/store';
import { IBusinessUserRolesRequest, IBusinessUserRolesResponse } from '../models/business-user-roles.model';
import * as authActions from '../actions';

export const businessUserRoleFeatureKey = 'businessUserRoles';

export interface BusinessUserRoleState {
  loadBusinessUserRolesRequest: IBusinessUserRolesRequest;
  loadBusinessUserRolesRequestSuccess: IBusinessUserRolesResponse;
  loadBusinessUserRolesRequestFailure: Error | any;
}

export const initialState: BusinessUserRoleState = {
  loadBusinessUserRolesRequest: undefined,
  loadBusinessUserRolesRequestSuccess: undefined,
  loadBusinessUserRolesRequestFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(authActions.loadBusinessUserRoles, (state, action) => ({
    ...state,
    loadBusinessUserRolesRequest: action.request
  })),
  on(authActions.loadBusinessUserRolesSuccess, (state, action) => ({
    ...state,
    loadBusinessUserRolesRequestSuccess: action.response
  })),
  on(authActions.loadBusinessUserRolesFailure, (state, action) => ({
    ...state,
    loadBusinessUserRolesRequestFailure: action.error
  }))
);

export const getBusinessUserRoles = (state: BusinessUserRoleState) => state.loadBusinessUserRolesRequestSuccess;
